import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { CompanyStageResources } from 'services/resources/preferences/company-stage';

import { Page } from './components/Page';

export const CompanyStagePage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('company-stage');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={CompanyStageResources}
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
